import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { ShiftDocument, shiftPullQueryBuilder } from './queryBuilder';

export function shiftFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<ShiftDocument> {
  const syncConfig = configBuilder<ShiftDocument>(RxdbCollectionNameV2.SHIFT);
  doNotAutoSync(syncConfig);

  pull(syncConfig, shiftPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.SHIFT, replicationState, [sites]);
}
